import { render, staticRenderFns } from "./tournament-registration.vue?vue&type=template&id=e6373dae&scoped=true&"
import script from "./tournament-registration.vue?vue&type=script&lang=js&"
export * from "./tournament-registration.vue?vue&type=script&lang=js&"
import style0 from "./tournament-registration.vue?vue&type=style&index=0&id=e6373dae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6373dae",
  null
  
)

export default component.exports